import {
  Autocomplete,
  Backdrop,
  Box,
  Chip,
  Menu,
  Typography,
  styled,
} from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  secondGridBox: 'secondGridBox',
  searchField: 'searchField',
  tagButton: 'tagButton',
  popOverBox: 'popOverBox',
  createPopOverButton: 'createPopOverButton',
  tabs: 'tabs',
  stagSelectDropdownButton: 'stagSelectDropdownButton',
  addTagIcon: 'addTagIcon',
  arrowDownIconWithTransition: 'arrowDownIconWithTransition',
  arrowDownIconWithoutTransition: 'arrowDownIconWithoutTransition',
  invoicesAgGridStyle: 'invoicesAgGridStyle',
  loaderBox: 'loaderBox',
  uploadLoader: 'uploadLoader',
};

export const TagNameTypography = styled(Typography)(() => ({
  overflowWrap: 'anywhere',
}));

export const PopoverContainer = styled(Box)({
  [up('xs')]: {
    padding: '5px',
  },
  [up('sm')]: {
    padding: '5px',
  },
  [up('md')]: {
    padding: '5px',
  },
  [up('lg')]: {
    padding: '6px',
  },
  [up('xl')]: {
    padding: '7px',
  },
  [up('xxl')]: {
    padding: '10px',
  },
});
export const SelectTagAutoComplete = styled(Autocomplete)({
  [up('xs')]: {
    width: '18.5vw',
  },
  [up('sm')]: {
    width: '17.5vw',
  },
  [up('md')]: {
    width: '15vw',
  },
  [up('lg')]: {
    width: '14vw',
  },
  [up('xl')]: {
    width: '12vw',
  },
  [up('xxl')]: {
    width: '13vw',
  },
});
export const AddTagIconBox = styled(Box)({
  marginRight: '8px',
  [up('xs')]: {
    height: '10px',
    width: '10px',
  },
  [up('sm')]: {
    height: '12px',
    width: '12px',
  },
  [up('md')]: {
    height: '14px',
    width: '14px',
  },
  [up('lg')]: {
    height: '16px',
    width: '16px',
  },
  [up('xl')]: {
    height: '18px',
    width: '18px',
  },
  [up('xxl')]: {
    height: '20px',
    width: '20px',
  },
});

export const SelectStageMenu = styled(Menu)({
  top: '0.5%',
  right: '5%',
  '& .MuiPaper-root': {
    [up('xs')]: {
      width: '70px',
    },
    [up('sm')]: {
      width: '100px',
    },
    [up('md')]: {
      width: '100px',
    },
    [up('lg')]: {
      width: '110px',
    },
    [up('xl')]: {
      width: '130px',
    },
    [up('xxl')]: {
      width: '150px',
    },
  },
});

export const AddTagIconContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

export const ChipStyled = styled(Chip)(({ theme }) => ({
  border: 'none',
  color: theme.palette.darkPurple.main,
  background: theme.palette.japanBlush.main,
  cursor: 'pointer',
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: `calc(100vh - ${theme.spacing(6)});`,
    padding: '20px',

    // [up('xs')]: {
    //   padding: '16px',
    // },
    // [up('md')]: {
    //   padding: '20px',
    // },
    // [up('xs')]: {
    //   padding: '0px 14px',
    // },
    // [up('sm')]: {
    //   padding: '0px 16px',
    // },
    // [up('md')]: {
    //   padding: '0px 18px',
    // },
    // [up('lg')]: {
    //   padding: '0px 20px',
    // },
    // [up('xl')]: {
    //   padding: '0px 23px',
    // },
    // [up('xxl')]: {
    //   padding: '0px 25px',
    // },
  },
  [`& .${classes.secondGridBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.arrowDownIconWithTransition}`]: {
    transform: 'rotate(180deg)',
    transition: 'transform  0.3s ease',
  },
  [`& .${classes.arrowDownIconWithoutTransition}`]: {
    transform: 'none',
    transition: 'transform  0.3s ease',
  },
  [`& .${classes.searchField}`]: {
    marginRight: '1vw',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        width: '155px',
        height: '8px',
      },
      [up('sm')]: {
        width: '100px',
        height: '13px',
      },
      [up('md')]: {
        width: '125px',
        height: '13px',
      },
      [up('lg')]: {
        width: '145px',
        height: '18px',
      },
      [up('xl')]: {
        width: '185px',
        height: '23px',
      },
      [up('xxl')]: {
        width: '210px',
        height: '29px',
      },
    },
  },
  [`& .${classes.tagButton}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
    background: theme.palette.darkPurple.lightest,
    color: theme.palette.darkPurple.main,
    ':hover': {
      background: theme.palette.darkPurple.lightest,
      color: theme.palette.darkPurple.main,
    },
    [up('xs')]: {
      width: '70px',
      height: '27px',
    },
    [up('sm')]: {
      width: '70px',
      height: '32px',
    },
    [up('md')]: {
      width: '70px',
      height: '32px',
    },
    [up('lg')]: {
      width: '80px',
      height: '37px',
    },
    [up('xl')]: {
      width: '100px',
      height: '43px',
    },
    [up('xxl')]: {
      width: '108px',
      height: '48px',
    },
  },
  [`& .${classes.popOverBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    width: '18vw',
  },
  [`& .${classes.createPopOverButton}`]: {
    backgroundColor: theme.palette.dynamicBlack.lightest,
  },

  [`& .${classes.tabs}`]: {
    fontFamily: 'Heebo',
    fontWeight: 400,
    textTransform: 'none',
    [up('xs')]: {
      padding: '18px 14px',
    },
    [up('sm')]: {
      padding: '8px 14px',
    },
    [up('md')]: {
      padding: '10px 18px',
    },
    [up('lg')]: {
      padding: '12px 22px',
    },
    [up('xl')]: {
      padding: '14px 26px',
    },
    [up('xxl')]: {
      padding: '16px 30px',
    },
  },
  [`& .${classes.stagSelectDropdownButton}`]: {
    marginRight: '1vw',
    background: theme.palette.darkPurple.lightest,
    color: theme.palette.darkPurple.main,
    ':hover': {
      background: theme.palette.darkPurple.lightest,
      color: theme.palette.darkPurple.main,
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      width: '70px',
      height: '27px',
    },
    [up('sm')]: {
      width: '100px',
      height: '32px',
    },
    [up('md')]: {
      width: '100px',
      height: '32px',
    },
    [up('lg')]: {
      width: '110px',
      height: '37px',
    },
    [up('xl')]: {
      width: '130px',
      height: '43px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '48px',
    },
  },
  [`& .${classes.invoicesAgGridStyle}`]: {
    // height: 'calc(100vh - 64px - 64px - 20px)',
    height: '100%',
    // [up('xs')]: {
    //   height: '55vh',
    // },
    // [up('sm')]: {
    //   height: '68vh',
    // },
    // [up('md')]: {
    //   height: '67vh',
    // },
    // [up('lg')]: {
    //   height: '70vh',
    // },
    // [up('xl')]: {
    //   height: '77vh',
    // },
    // [up('xxl')]: {
    //   height: '77.8vh',
    // },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '40vh',
    },
    [up('sm')]: {
      height: '50vh',
    },
    [up('md')]: {
      height: '55vh',
    },
    [up('lg')]: {
      height: '60vh',
    },
    [up('xl')]: {
      height: '60vh',
    },
    [up('xxl')]: {
      height: '70vh',
    },
  },
  [`& .${classes.uploadLoader}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
